import React, { useEffect, useState } from 'react';

import { redeemHandoff, storeHandoffSession } from './handoff.js';

function fragmentParams() {
  const raw = (window.location.hash || '').replace(/^#/, '');
  return new URLSearchParams(raw);
}

/**
 * Target-product landing. Reads the code from the fragment, redeems it
 * on this origin, stores the JWT pair, and opens ``next``.
 */
export default function HandoffPage() {
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const params = fragmentParams();
    const code = params.get('code') || '';
    const next = params.get('next') || '/';
    if (!code) {
      setError('This switch link is missing its code.');
      return undefined;
    }
    redeemHandoff(code, next)
      .then((payload) => {
        if (cancelled) return;
        storeHandoffSession(payload);
        const target = payload.next || '/';
        window.history.replaceState(null, '', target);
        window.location.assign(target);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Could not sign you in.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="ty-fullscreen-center">
      {error ? <p>{error}</p> : <div className="ty-spinner" aria-label="Signing you in" />}
    </div>
  );
}
